export const environment = {
  googleMapsApiKey: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
  apiUrl: process.env.REACT_APP_API_URL || "http://localhost:3001",
  env: process.env.REACT_APP_ENV || "development",
  version: process.env.REACT_APP_VERSION || "local",
};
